import { actionTypes, mutationTypes, getterTypes } from './common.moduletypes';

const actions = {
  [actionTypes.getSchedules]({ getters, commit }, data) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].getSchedules(data).then(result => {
        commit(mutationTypes.setSchedules, result.data);
        resolve(result);
      });
    });
  },
  [actionTypes.exportSchedule]({ getters }, data) {
    const { exportFileName } = data;
    return new Promise(resolve => {
      getters[getterTypes.commonApi].exportSchedule(data).then(result => {
        if (!window.navigator.msSaveOrOpenBlob) {
          // BLOB NAVIGATOR
          const url = window.URL.createObjectURL(new Blob([result.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', exportFileName);
          document.body.appendChild(link);
          link.click();
        } else {
          // BLOB FOR EXPLORER 11
          const url = window.navigator.msSaveOrOpenBlob(new Blob([result.data]), exportFileName);
        }
        resolve(result);
      });
    });
  },
  [actionTypes.getProfile]({ getters, commit }, data) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].getProfile(data).then(result => {
        commit(mutationTypes.setUserProfile, result.data);
        resolve(result);
      });
    });
  },
  [actionTypes.editProfile]({ getters, dispatch, commit }, { data, profileImage }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.commonApi]
        .editProfile(data)
        .then(() => {
          commit(mutationTypes.updateUserProfile, data);
          let promises = [];
          if (profileImage !== '') {
            promises.push(dispatch(actionTypes.uploadProfileImage, profileImage));
          }
          if (data.oems) {
            promises.push(dispatch(actionTypes.setOemFilter, { oems: data.oems }));
          }
          return Promise.all(promises).then(() => {
            resolve();
          });
        })
        .catch(error => {
          console.error('Error occured in editProfile: ' + error);
          reject();
        });
    });
  },
  [actionTypes.getRegions]({ getters, commit }) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].getRegions().then(result => {
        commit(mutationTypes.setRegions, result.data);
        resolve(result);
      });
    });
  },
  [actionTypes.uploadProfileImage]({ getters }, data) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].uploadProfileImage(data).then(result => {
        resolve(result);
      });
    });
  },

  [actionTypes.getAllNews]({ getters, commit }) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].getNews().then(result => {
        let { data } = result;
        commit(mutationTypes.setAllNews, data.news);
        resolve(result);
      });
    });
  },

  [actionTypes.getOneNews]({ getters, commit }, newsId) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].getOneNews(newsId).then(result => {
        let { data } = result;
        commit(mutationTypes.setOneNews, data);
        resolve(result);
      });
    });
  },

  [actionTypes.getRecommendations]({ getters, commit }, data) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].getRecommendations(data).then(result => {
        let { data } = result;
        commit(mutationTypes.setRecommendations, data);
        resolve(result);
      });
    });
  },

  [actionTypes.getRecommendationsBySpecification]({ getters, commit }, data) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].getMachineTypesForUnitBySpecification(data).then(result => {
        let { data } = result;
        commit(mutationTypes.setRecommendations, data);
        resolve(result);
      });
    });
  },

  [actionTypes.addCustomRecommendation]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.commonApi]
        .addCustomRecommendation(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in addCustomRecommendation: ' + error);
          reject();
        });
    });
  },

  [actionTypes.acceptTos]({ getters }, version) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.commonApi]
        .acceptTos(version)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in acceptTos: ' + error);
          reject();
        });
    });
  },

  [actionTypes.getWireOems]({ getters, commit }) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.commonApi]
        .getWireOems()
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setWireOems, data);
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in getWireOems: ' + error);
          reject();
        });
    });
  },

  [actionTypes.setOemFilter]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.commonApi]
        .setOemFilter(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in setOemFilter: ' + error);
          reject();
        });
    });
  },

  [actionTypes.getLogData]({ getters, commit }, requestData) {
    let { resetPreviousData } = requestData;
    delete requestData.resetPreviousData;
    return new Promise((resolve, reject) => {
      getters[getterTypes.commonApi]
        .getLogData(requestData)
        .then(result => {
          let { data } = result;
          commit(mutationTypes.setLogData, { data, lastPage: requestData.page, resetPreviousData });
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in getLogData: ' + error);
          reject();
        });
    });
  },

  [actionTypes.getLogFilterData]({ getters, commit }) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].getLogFilterData().then(result => {
        let { data } = result;
        commit(mutationTypes.setLogFilterData, data);
        resolve(result);
      });
    });
  },

  [actionTypes.getNotificationSettings]({ getters, commit }) {
    return new Promise(resolve => {
      getters[getterTypes.commonApi].getNotificationSettings().then(result => {
        let { data } = result;
        commit(mutationTypes.setNotificationSettings, data.unitNotifcationSettings);
        resolve(result);
      });
    });
  },

  [actionTypes.updateNotificationSetting]({ getters }, data) {
    return new Promise((resolve, reject) => {
      getters[getterTypes.commonApi]
        .updateNotificationSetting(data)
        .then(result => {
          resolve(result);
        })
        .catch(error => {
          console.error('Error occured in updateNotificationSetting: ' + error);
          reject();
        });
    });
  }
};
export default actions;
